// import ssoImg1 from "./../../../../assets/images/naval-architecture-img.png"; // Adjust the path as necessary
import ssoImg1 from "./../../../../assets/images/naval.jpeg"; 
function NavalArchitectureOverviewTab() {

  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        NAVAL ARCHITECTURE 
        <span className="text-orange-ef3e33 font-400"> overview </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          
          <p className="mb-3 text-primary-color">The Naval Architect and the Registrar of Ships is jointly responsible for  managing all aspects of the construction (building) of new vessels and  any modifications to all aspects of the vessel is recorded</p>

          <p className="mb-3 text-primary-color">Naval architecture capability is provided within SAMSA to provide statutory naval architecture services which include:</p>

          <ul className="green-star-ul">
            <li>Technical assistance for plan review of New Buildings</li>
            <li>Vessels for which Alterations or Additions are planned</li>
            <li>Stability Assessment</li>
            <li>Built-in Buoyancy Assessment​</li>
            <li>Load Line Computations</li>
            <li>Tonnage Computations</li>
            <li>Generation of Technical Policy</li>
            <li>Provision of training</li>
          </ul>

         


        </div>
        <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div>
       <p className="mb-3 font-700 text-primary-color text-uppercase">
        For guidance on SAMSA's Naval Architecture policy matters please contact your nearest SAMSA Office
        </p>

      
      </div>
    </>
  );
}

export default NavalArchitectureOverviewTab;